/**
 * Generated runtime TestId mirror for frontend/src/features/onboarding/steps/ReviewStep.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const ReviewStepTestIds = {
  cardTitleReviewAttributes: "card-title-review-attributes",
  cardTitleReviewIdentity: "card-title-review-identity",
  cardTitleReviewOrganization: "card-title-review-organization",
  cardTitleReviewPerson: "card-title-review-person",
  reviewDisplayName: "review-display-name",
  reviewEditIdentity: "review-edit-identity",
  reviewEditOrganization: "review-edit-organization",
  reviewEditPerson: "review-edit-person",
  reviewSectionIdentity: "review-section-identity",
  reviewSectionOrganization: "review-section-organization"
} as const;
